import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./modelos.component.html')
})
export class ModelosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/modelos/modelos.component.ts
 **/